import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section id="bonos" className="defer-paint w-full scroll-mt-6 bg-coal py-12 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-13" data-mp="vsmkwis5ima0">
      <div className="mx-auto max-w-5xl px-6" data-id="element-14" data-mp="qs8awv6zp29c">
        <SectionHeading eyebrow="Para entrenadores de atletismo" title={<span id="bonuses-heading" data-id="element-16" data-mp="14r7z61qlbf4z">+ 5 bonos exclusivos</span>} lead="Herramientas tácticas para ganar autoridad en la pista y resolver situaciones reales." data-id="element-15" data-mp="14tknqxqusnr0" />

        {/* Tarjetas horizontales, dos por renglón: la portada a la izquierda y
            el contenido a la derecha, para que la sección no se haga extensa. */}
        <ul className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-17" data-mp="1njamfvxqlto7">
          {bonuses.map((bonus, index) => <li key={bonus.number} className={`flex gap-4 rounded-2xl border border-line bg-ink p-4 sm:gap-5 sm:p-5 ${index === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-18" data-mp="1jj9xvigxc23f" data-mpi={index}>
              <img src={bonus.image} alt={bonus.alt} className="h-auto w-24 shrink-0 self-start rounded-xl object-cover sm:w-28" width={1024} height={1024} sizes="112px" loading="lazy" decoding="async" data-id="element-19" data-mp="3tu00bt98pqlu" />

              <div className="min-w-0 flex-1" data-id="element-20" data-mp="gklra1w34dcz">
                <div className="flex items-center justify-between gap-3" data-id="element-21" data-mp="gjani22n35lv">
                  <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-stone" data-id="element-22" data-mp="lcncwef57gfo">
                    Bono {bonus.number}
                  </p>
                  <span className="shrink-0 rounded-full bg-gold px-2.5 py-1 font-sans text-[9px] font-bold uppercase tracking-[0.16em] text-ink" data-id="element-23" data-mp="vb2sbk4t519c">
                    Gratis
                  </span>
                </div>

                <h3 className="mt-2 font-display text-lg font-bold leading-snug text-ivory sm:text-xl" data-id="element-24" data-mp="am0jebiarz5n">
                  {bonus.title}
                </h3>
                <p className="mt-2 font-sans text-[0.82rem] leading-relaxed text-stone" data-id="element-25" data-mp="kas727gbrxar">
                  {bonus.tagline}
                </p>

                <ul className="mt-3 flex flex-wrap gap-x-4 gap-y-1.5" data-id="element-26" data-mp="fjjz7fun8jzp">
                  {bonus.bullets.map(bullet => <li key={bullet} className="flex items-center gap-1.5 font-sans text-[0.75rem] leading-snug text-ivory/80" data-id="element-27" data-mp="tdtdyad0lsfh">
                      <CheckIcon className="h-3 w-3 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-28" data-mp="1394ripcostln" />
                      {bullet}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}